/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPayorSourceSummary } from './HchbPayorSourceSummary';
import {
    HchbPayorSourceSummaryFromJSON,
    HchbPayorSourceSummaryFromJSONTyped,
    HchbPayorSourceSummaryToJSON,
} from './HchbPayorSourceSummary';

/**
 * 
 * @export
 * @interface HchbPayorTypeSummary
 */
export interface HchbPayorTypeSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbPayorTypeSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPayorTypeSummary
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorTypeSummary
     */
    active: boolean;
    /**
     * 
     * @type {Array<HchbPayorSourceSummary>}
     * @memberof HchbPayorTypeSummary
     */
    sources: Array<HchbPayorSourceSummary>;
}

/**
 * Check if a given object implements the HchbPayorTypeSummary interface.
 */
export function instanceOfHchbPayorTypeSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "sources" in value;

    return isInstance;
}

export function HchbPayorTypeSummaryFromJSON(json: any): HchbPayorTypeSummary {
    return HchbPayorTypeSummaryFromJSONTyped(json, false);
}

export function HchbPayorTypeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorTypeSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'sources': ((json['sources'] as Array<any>).map(HchbPayorSourceSummaryFromJSON)),
    };
}

export function HchbPayorTypeSummaryToJSON(value?: HchbPayorTypeSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'active': value.active,
        'sources': ((value.sources as Array<any>).map(HchbPayorSourceSummaryToJSON)),
    };
}

